import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";

export const ProfileButton = () => {
    const [togglePopup, setTogglePopup] = useState(true);
    const handleToggle = () => {
        setTogglePopup(!togglePopup)
        document.body.classList.toggle('showProfile');
    };

    return (
        <button onClick={handleToggle} className="profile-button">
            <div className="profile-button--text">
                Profile
            </div>
            <FontAwesomeIcon
                icon={togglePopup ? faChevronLeft : faChevronRight}
            />
        </button>
    );
};



// WEBPACK FOOTER //
// ./src/frontend/components/LearnerHome/ProfileButton.js